import React from 'react';
import PropTypes, { func } from 'prop-types';
import { Body2, mergeClasses, Title2 } from '@fluentui/react-components';

import { useBannerContainerStyles } from './style';

export const Banner = ({ i18n }) => {
  const classes = useBannerContainerStyles();

  return (
    <div className={mergeClasses(
      'ads-studio-top-banner-container',
      classes.bannerContainer
    )}
    >
      <div>
        <Title2 as="h1" className={mergeClasses('display-templates-banner-title', classes.heading)} aria-label={i18n.getString(_TL_('Display templates'))} block>
          {i18n.getString(_TL_('Display templates'))}
        </Title2>
        <Body2 as="p" className="display-templates-banner-description" aria-label={i18n.getString(_TL_('Create visually appealing templates for your Display ads to save time during campaign creation.'))}>
          {i18n.getString(_TL_('Create visually appealing templates for your Display ads to save time during campaign creation.'))}
        </Body2>
      </div>
    </div>
  );
};

Banner.propTypes = {
  i18n: PropTypes.shape({ getString: func }).isRequired,
};

